@if (pageInfo()) {
  <app-tools-jumbotron
    [latestUpdate]="latestUpdateDate ? latestUpdate : undefined"
    [pageInfo]="pageInfo()"
  ></app-tools-jumbotron>
}
<div
  class="container mx-auto sm:px-0 px-4 sm:mt-[72px] mt-6 grid grid-cols-1 md:grid-cols-3 gap-4 mb-3"
>
  @for (blog of blogList(); track $index) {
    <app-card [blog]="blog"></app-card>
  }
</div>
